import type { TracedLayout } from '../traced';

/**
 * Layout traced from a top-down overview image of a well-known map (`cs_mirage_radar.png`) by tools/trace-map.py:
 * `#` wall, `.` floor, `c` low cover, run-length encoded (`12#` = twelve walls). Cells are 0.5 m; the longest side is 80.0 m.
 * The image itself is not in the repository.
 */
export const MIRAGE_LAYOUT: TracedLayout = {
  cell: 0.5,
  width: 160,
  height: 132,
  spawns: [{ x0: 138.2, z0: 29.6, x1: 151.8, z1: 48.9 }, { x0: 23.6, z0: 90.4, x1: 45.8, z1: 113.3 }],
  sites: [{ x0: 16.9, z0: 17.4, x1: 30.5, z1: 32.5 }, { x0: 75.2, z0: 109.0, x1: 89.4, z1: 119.9 }],
  rows: [
    '80#14.19#11.36#',
    '22#15.43#23.#20.36#',
    '22#22.36#44.36#',
    '12#51.17#44.36#',
    '10#114.36#',
    '10#114.36#',
    '10#114.36#',
    '10#.6c77.9#33.24#',
    '11#6c77.9#34.23#',
    '11#.5c77.9#37.20#',
    '10#84.9#48.9#',
    '10#84.9#48.9#',
    '10#84.9#47.10#',
    '94.9#48.9#',
    '94.10#47.9#',
    '94.12#44.10#',
    '94.12#44.10#',
    '94.12#44.10#',
    '#17.3c73.12#44.10#',
    '18.3c73.12#44.10#',
    '18.3c73.12#10.18#16.10#',
    '18.3c73.12#10.18#16.10#',
    '74.7#13.12#8.21#15.10#',
    '73.30#12.20#15.10#',
    '73.30#12.20#15.10#',
    '73.30#12.20#15.10#',
    '73.30#12.22#13.10#',
    '73.30#12.22#13.10#',
    '26.4c43.30#12.22#13.10#',
    '26.4c43.30#12.22#13.10#',
    '25.5c43.30#12.22#15.8#',
    '#41.c29.31#12.22#16.7#',
    '11#31.c.10#11.2c5.31#12.22#16.7#',
    '11#33.10#11.2c5.31#12.22#16.7#',
    '11#33.10#18.31#12.22#16.7#',
    '10#34.10#18.31#12.22#16.7#',
    '9#35.10#19.30#16.18#16.7#',
    '9#35.10#19.30#16.18#16.7#',
    '9#35.10#19.30#16.18#23.',
    '9#35.10#19.30#16.18#23.',
    '9#35.10#19.30#16.18#23.',
    '9#35.10#20.29#16.18#23.',
    '9#35.10#22.26#17.18#23.',
    '9#35.10#22.23#.2#17.18#22.#',
    '9#26.5#4.10#22.23#20.19#15.7#',
    '10#5.5#2.5c6.21#65.19#15.7#',
    '10#5.5#2.5c6.21#65.19#15.7#',
    '10#5.5#13.21#65.19#15.7#',
    '10#5.5#13.21#65.19#15.7#',
    '10#5.5#13.18#.2#65.19#15.7#',
    '10#6.4#14.17#68.19#14.8#',
    '10#32.9#68.19#13.9#',
    '10#32.9#68.19#13.9#',
    '10#32.9#68.19#13.9#',
    '10#33.8#68.19#13.9#',
    '10#32.9#68.19#13.9#',
    '10#32.9#68.19#13.9#',
    '10#32.9#68.19#13.9#',
    '10#33.8#68.19#13.9#',
    '10#7.4c21.9#68.19#13.9#',
    '10#.11#.12#7.9#68.19#13.9#',
    '35#84.19#13.9#',
    '35#84.19#13.9#',
    '35#84.19#13.9#',
    '35#84.19#13.9#',
    '35#25.8#51.19#13.9#',
    '35#25.8#51.19#13.9#',
    '35#25.8#51.19#13.9#',
    '35#25.8#51.19#13.9#',
    '35#25.8#13.2#36.19#13.9#',
    '35#25.8#13.56#14.9#',
    '35#25.8#13.43#27.9#',
    '35#25.8#13.42#28.9#',
    '35#25.9#12.42#28.9#',
    '35#25.9#12.39#31.9#',
    '35#25.8#13.38#32.9#',
    '35#25.8#13.38#32.9#',
    '35#24.9#13.38#32.9#',
    '35#10.6#8.9#13.38#32.9#',
    '35#10.6#8.9#13.38#32.9#',
    '35#10.6#30.38#32.9#',
    '35#10.6#30.38#32.9#',
    '35#10.6#30.38#32.9#',
    '35#10.6#30.38#32.9#',
    '35#10.6#30.11#59.9#',
    '35#10.6#30.10#60.9#',
    '35#10.6#30.10#60.9#',
    '35#10.6#100.9#',
    '35#10.6#100.9#',
    '35#10.6#100.9#',
    '24#112.24#',
    '24#25.18#69.24#',
    '24#25.18#69.24#',
    '24#25.18#69.24#',
    '24#25.18#69.24#',
    '24#25.18#69.24#',
    '24#23.20#69.24#',
    '24#23.20#72.21#',
    '24#23.20#39.#22.2#9.20#',
    '24#23.20#32.2c5.25#9.20#',
    '24#23.20#39.25#9.20#',
    '24#23.20#39.25#9.20#',
    '24#22.21#39.25#9.20#',
    '24#22.21#39.25#9.20#',
    '24#22.21#39.9#4.3#4.5#9.20#',
    '24#22.21#73.20#',
    '24#22.21#73.20#',
    '24#22.21#73.20#',
    '24#22.21#10.3c60.20#',
    '23#23.21#10.3c9.c50.20#',
    '24#25.18#73.20#',
    '24#25.18#73.20#',
    '24#25.18#73.20#',
    '36#13.18#71.22#',
    '37#13.17#29.#41.22#',
    '36#60.#43.20#',
    '38#58.#43.20#',
    '38#58.#43.20#',
    '38#49.2c7.#43.20#',
    '39#47.2c8.#43.20#',
    '40#46.2c8.#43.20#',
    '39#57.#40.#.21#',
    '41#42.#12.19#11.34#',
    '44#36.80#',
    '44#.2#30.#2.80#',
    '48#18.2c9.83#',
    '52#14.2c6.86#',
    '53#2.#10.2c3.#2.86#',
    '57#10.#3.89#',
    '61#6.93#',
    '61#2.2#2.93#',
    '160#',
  ],
};
